/* tslint:disable */
/* eslint-disable */
/**
 * Gallaudet
 * A set of APIs to allow seamless integration of the NUSA Roblox game
with Google Classrooms.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';

/**
 * 
 * @export
 * @interface ProjectAlreadyExistsErrorResponseContent
 */
export interface ProjectAlreadyExistsErrorResponseContent {
    /**
     * An error message
     * @type {string}
     * @memberof ProjectAlreadyExistsErrorResponseContent
     */
    message: string;
}


/**
 * Check if a given object implements the ProjectAlreadyExistsErrorResponseContent interface.
 */
export function instanceOfProjectAlreadyExistsErrorResponseContent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "message" in value;
    return isInstance;
}

export function ProjectAlreadyExistsErrorResponseContentFromJSON(json: any): ProjectAlreadyExistsErrorResponseContent {
    return ProjectAlreadyExistsErrorResponseContentFromJSONTyped(json, false);
}

export function ProjectAlreadyExistsErrorResponseContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectAlreadyExistsErrorResponseContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'message': json['message'],
    };
}

export function ProjectAlreadyExistsErrorResponseContentToJSON(value?: ProjectAlreadyExistsErrorResponseContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'message': value.message,
    };
}

